import DaumPostCose from 'react-daum-postcode';
import styled from 'styled-components';
import { DimmedBackground } from '../../../common/dimmed/DimmedBackground';

interface DaumPostCodeModalProps {
  isShow: boolean;
  onClose: () => void;
  onSearchFinished: (searchedRegion: string) => void;
}

export const DaumPostCodeModal = ({ isShow, onClose, onSearchFinished }: DaumPostCodeModalProps) => {
  const handleDaumPostCodeComplete = (data: any) => {
    onSearchFinished(data.roadAddress);
    onClose();
  };

  return (
    <DimmedBackground isShow={isShow} onClick={onClose}>
      <Container
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <DaumPostCose
          onComplete={handleDaumPostCodeComplete}
          autoClose={false}
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Container>
    </DimmedBackground>
  );
};

const Container = styled.div`
  width: 320px;
  height: 480px;

  position: absolute;

  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);

  border-radius: 8px;
  background-color: white;

  overflow: hidden;
`;
